import type * as React from "react";
import { useCurrentPdf } from "@/views/chat/hooks/useCurrentPdf";
import { useGetFileDetailsQuery } from "@/api/files";

export const RightDrawerDocumentName: React.FC = () => {
  const { currentPdfId } = useCurrentPdf();

  const { data: fileDetails } = useGetFileDetailsQuery({ fse_id: currentPdfId || "" });

  return (
    <div className="text-color-text-ui-heading-text mx-2 my-3 line-clamp-2 flex-grow pr-2 text-center text-xs font-semibold">
      {fileDetails?.name}
    </div>
  );
};
